import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { incidentsPageEntryPoint as incidentsPageEntryPointDeprecated } from '@atlassian/jira-software-incidents-page/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';

export const entryPointDeprecated = createPageEntryPoint({
	main: incidentsPageEntryPointDeprecated,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
